import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { EditorConfigContext } from '../../contexts/EditorConfigContext';
import { useSummaryCommand } from './useSummaryCommand';
import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { RTEToolbarLoadingButton } from '../../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { BulbIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InsertGeneratedAISummary() {
  const editorConfig = useContext(EditorConfigContext);
  const summaryConfig = editorConfig.AI_SUMMARY;
  const globalSettingEnabled = summaryConfig ? summaryConfig.globalSettingEnabled : false;
  const settingsUrl = `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;
  const {
    isLoading: isGeneratingSummary,
    generateSummary
  } = useSummaryCommand();
  return /*#__PURE__*/_jsx(Tooltip, {
    title: globalSettingEnabled ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.insertSummary"
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.tooltips.customerAnalysisSettingOff_jsx',
      elements: {
        Link
      },
      options: {
        href: settingsUrl,
        external: true
      }
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarLoadingButton, {
      size: "extra-small",
      loading: isGeneratingSummary,
      onClick: generateSummary,
      disabled: !globalSettingEnabled,
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: BulbIcon,
        disabled: !globalSettingEnabled
      })
    })
  });
}